"use strict";

exports.__esModule = true;
exports.TitleText = exports.SortDropdownTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TitleText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "components__TitleText",
  componentId: "sc-1m9e1cm-0"
})(["white-space:nowrap;"]);
exports.TitleText = TitleText;
var labelFontObject = {
  color: "body-grey",
  fontSize: 0,
  fontWeight: 1,
  letterSpacing: "1.5px",
  lineHeight: 1
};
var dropdownFont = {
  color: "text-title",
  fontSize: 1,
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: 2
};

var SortDropdownTitle = function SortDropdownTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(TitleText, _extends({
    overflow: "hidden",
    pr: 1
  }, dropdownFont), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({}, labelFontObject, {
    mr: "4px"
  }), "SORT BY:"), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    display: "inline-block"
  }, children));
};

exports.SortDropdownTitle = SortDropdownTitle;
SortDropdownTitle.propTypes = {
  children: _propTypes.node
};